import Stars from './Stars';
import Text from './Text';

const index = {
  Stars,
  Text,
};

export default index;